import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { isNil, cloneDeep } from 'lodash-es';

import { ShellService, EModalSize, EToasterType, EToasterPosition } from './shell.service'
export { EModalSize, EToasterType, EToasterPosition } from './shell.service';
import { ToastrService } from 'ngx-toastr';

import { FootPrintPortalManager_ShellService } from './FootPrintPortalManager.shell.service';

@Injectable({ providedIn: 'root' })
export class app_ShellService extends ShellService  {
  constructor(
    dialog : MatDialog,
    toastr: ToastrService,
    public FootPrintPortalManager: FootPrintPortalManager_ShellService,
  ) {
    super(dialog, toastr);
  }

  public app: app_ShellService = this;

  // wizards shouldn't be opened in blades (hacky check with "#unless steps" to recognize the config type)

  public getComponentInformation(referenceName: string, params: ParamMap): { title: string, component: any, inParams: any } {

    let result = null;
    result = this.FootPrintPortalManager.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    return result;
  }
}
